<task-completion-blockers [content]="$content()">
  <wb-checkbox [(checked)]="$authorised" [label]="$content().optInLabel" />
</task-completion-blockers>
<footer class="actions">
  @if ($overridable()) {
    <wb-button label="Cancel" [size]="buttonSize" (onClick)="dismiss()" />
    <wb-button label="Complete" [displayStyle]="primary" [size]="buttonSize" [disabled]="!$authorised()" (onClick)="complete()" />
  } @else {
    <wb-button label="OK" [displayStyle]="primary" [size]="buttonSize" (onClick)="dismiss()" />
  }
</footer>
